import { useQuery } from '@tanstack/react-query';
import { useTenantContext } from 'src/context/useTenantContext';
import { tenantMenu } from 'src/services/apis/tenantRequests';
import { QUERIES } from 'src/utils/react-query';

export const useMenu = () => {
  const { orgSlug, restaurantId } = useTenantContext();
  return useQuery([QUERIES.MENU, orgSlug, restaurantId], () => tenantMenu({ orgSlug, restaurantId }));
};
